import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { Link, withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Collapse from '@material-ui/core/Collapse';
import ListItemText from '@material-ui/core/ListItemText';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { Avatar, Popover } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import BookIcon from '@material-ui/icons/Book';
import { gapi } from 'gapi-script';
import { ImHome } from 'react-icons/im';

import { Dropdown } from './Menus';
import axiosInstance, { API_URL, normalise } from './Constants';

import './Topbar.css';

const styles = (theme) => ({
  appBar: {
    position: 'relative',
    boxShadow: 'none',
    backgroundColor: 'rgba(255,255,255,0.1)',
    paddingTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(0),
    },
  },
  toolBar: {
    minHeight: 84,
    height: '100%',
    '& .MuiTabs-root': {
      height: '100%',
    },
    '& .MuiTabs-scroller': {
      display: 'flex',
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0px',
    },
  },
  inline: {
    display: 'inline',
    marginLeft: 16,
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      paddingTop: '0.5em',
      marginLeft: 0,
    },
  },
  flex: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  logo: {
    width: '50px',
    objectFit: 'contain',
    WebkitTouchCallout: 'none',
  },
  iconContainer: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  iconButton: {
    float: 'right',
  },
  tabContainer: {
    marginLeft: 16,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  indicator: {
    backgroundColor: theme.palette.primary.main,
  },
  tabItem: {
    textTransform: 'none',
    paddingTop: 20,
    paddingBottom: 20,
    minWidth: 140,
    minHeight: 84,
    fontSize: '1rem',
  },
  snsIcon: {
    cursor: 'pointer',
    marginLeft: 5,
    width: '0.8em',
    height: '0.8em',
  },

  //사용자정보 popver
  userInfoPopover: {
    pointerEvents: 'none',
  },
  popoverPaper: {
    padding: theme.spacing(2),
    // border: '1px solid #E5E5E5',
  },
  userInfoText: {
    fontWeight: 700,
  },
  logoutBtn: {
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  //menu
  topbarMenuRoot: {
    padding: '1em 2em',
  },
  topbarMenuText: {
    fontSize: '1em',
    color: '#fff',
    fontWeight: 700,
  },

  topbarUserInfoDiv: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  topbarSnsWeb: {
    textAlign: 'right',
    borderBottom: '2px solid rgba(245, 245, 245, 0.5)',
    padding: '0 24px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  //mobile
  mobileDrawerPaper: {
    width: '65%',
  },
  userProfileImg: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  mobileLogoutBtnLabel: {
    fontSize: '0.8em',
  },
  mobileStartBtnRoot: {
    color: theme.palette.primary.point,
    borderColor: theme.palette.primary.point,
    '&:hover': {
      borderColor: theme.palette.primary.point,
    },
    '&:active': {
      borderColor: theme.palette.primary.point,
    },
  },
  mobileStartBtnLabel: {
    fontSize: '0.9em',
  },
  mobileMenuText: {
    fontWeight: 600,
    fontSize: '1.2em',
    color: theme.palette.secondary.main,
  },
  mobileDropdownBtn: {
    '&:hover': {
      backgroundColor: '#1d1b55',
    },
    '&:active': {
      backgroundColor: '#1d1b55',
    },
  },
  mobileDropdownText: {
    fontSize: '1em',
    color: theme.palette.secondary.main,
    '&:hover': {
      color: '#fff',
    },
    '&:active': {
      color: '#fff',
    },
  },
});

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
    // border: `1px solid ${theme.palette.primary.main}`,
  },
  colorPrimary: {
    backgroundColor: '#f3f3f3',
  },
  bar: {
    borderRadius: 0,
    backgroundColor: theme.palette.primary.point,
  },
}))(LinearProgress);

class Topbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuDrawer: false,
      value: -1,
      anchorElMenu: null,
      anchorElInfo: null,
      selectedMenu: '',
      isMobileDropdownOpen: false, //모바일 드롭다운 메뉴
      totalCourse: 100,
      completedCourse: 20,
      pathname: this.props.currentPath ? this.props.currentPath.pathname.split('/')[1] : '',
      // userInfo: localStorage.getItem('loggedin') ? JSON.parse(localStorage.getItem(`${localStorage.getItem('loggedin')}_status`)) : null,
      userImg: '',
    };
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  mobileMenuOpen = (event) => {
    this.setState({ menuDrawer: true });
  };

  mobileMenuClose = (event) => {
    this.setState({ menuDrawer: false });
  };

  handleMobileDropdown(event, label) {
    event.stopPropagation();
    // console.log('선택한거', label);
    // console.log('eventCurrentTarget is ', event.currentTarget);
    if (label === this.state.selectedMenu) {
      this.setState({ isMobileDropdownOpen: false, selectedMenu: '' });
    } else {
      this.setState({ isMobileDropdownOpen: true, selectedMenu: label });
    }
  }

  handleDropdownClick(event, label) {
    event.stopPropagation();
    // console.log('선택한거', label);
    // console.log('eventCurrentTarget is ', event.currentTarget);
    this.setState({ anchorElMenu: event.currentTarget, selectedMenu: label });
  }

  handleDropdownClose = () => {
    this.setState({ anchorElMenu: null });
  };

  handleMenuItemClick(menuItem) {
    this.handleDropdownClose();
    this.setState({
      label: menuItem,
      content: menuItem,
      value: 'More',
    });
  }

  handlePopoverClick = (event) => {
    this.setState({ anchorElInfo: event.currentTarget });
  };

  handlePopoverClose = () => {
    this.setState({ anchorElInfo: null });
  };

  moveToSNS(sns) {
    let address = '';
    if (sns === 'homepage') {
      address = 'https://www.dsys.co.kr/';
    } else if (sns === 'facebook') {
      address = 'https://www.facebook.com/profile.php?id=100063789914525';
    } else if (sns === 'instagram') {
      address = 'https://www.instagram.com/doowon11/';
    } else if (sns === 'twitter') {
      address = 'https://twitter.com/';
    } else {
      address = 'https://blog.naver.com/dsys11/';
    }
    window.open(address, '_blank');
  }

  logout() {
    localStorage.removeItem(`${localStorage.getItem('loggedin')}_status`);
    localStorage.removeItem('loggedin');
    // localStorage.removeItem('st_token');
    // localStorage.removeItem('refreshToken');
    // if (localStorage.getItem('com.naver.nid.oauth.state_token')) {
    //   localStorage.removeItem('com.naver.nid.oauth.state_token');
    // }
    localStorage.clear();
    this.props.history.push('/');
    if (this.state.pathname === 'main') {
      window.location.reload();
    }
  }

  snsLogout = (response) => {
    const auth2 = gapi.auth2.getAuthInstance();
    // console.log(auth2);
    if (auth2 != null) {
      auth2.signOut().then(auth2.disconnet().then(console.log('GOOGLE LOGOUT SUCCESS')));
    }
    // console.log(response);
  };

  componentDidMount() {
    // console.log('currentPath: ', this.props.currentPath);
    // console.log(this.state.pathname);
    if (localStorage.getItem('loggedin') && localStorage.getItem(`${localStorage.getItem('loggedin')}_status`)) {
      this.setState({
        userInfo: JSON.parse(localStorage.getItem(`${localStorage.getItem('loggedin')}_status`)),
      });
      axiosInstance
        .get(`${API_URL}/user/info?userId=${localStorage.getItem('loggedin')}`, {})
        .then((res) => {
          if (res.data && res.data.img && res.data.img !== '') {
            this.setState({ userImg: res.data.img });
          }
          if (res.data && res.data.totalCourse && res.data.totalStamp) {
            this.setState({ totalCourse: res.data.totalCourse, totalStamp: res.data.totalStamp });
          }
          this.setState({
            userStamp: res.data.stamp ? res.data.stamp.length : 0,
            userCourse: res.data.course ? res.data.course.length : 0,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  current = () => {
    if (this.props.currentPath === '/') {
      return 0;
    }
    if (this.props.currentPath === '/session') {
      return 1;
    }
    if (this.props.currentPath === '/satellite') {
      return 2;
    }
    if (this.props.currentPath === '/exhibition') {
      return 3;
    }
    if (this.props.currentPath === '/mypage') {
      return 4;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <AppBar position="static" color="default" className={classes.appBar}>
        {/* Topbar SNS area - Web */}
        <div className={classes.topbarSnsWeb}>
          <ImHome
            style={
              this.state.pathname === 'mypage' || this.state.pathname === 'profile' || this.state.pathname === 'main'
                ? { color: '#fff', width: '1.2em', height: '1.2em' }
                : { color: '#555', width: '1.2em', height: '1.2em' }
            }
            className={classes.snsIcon}
            onClick={() => this.moveToSNS('homepage')}
          />

          <FacebookIcon
            style={
              this.state.pathname === 'mypage' || this.state.pathname === 'profile' || this.state.pathname === 'main'
                ? { color: '#fff' }
                : { color: '#555' }
            }
            className={classes.snsIcon}
            onClick={() => this.moveToSNS('facebook')}
          />
          <InstagramIcon
            style={
              this.state.pathname === 'mypage' || this.state.pathname === 'profile' || this.state.pathname === 'main'
                ? { color: '#fff' }
                : { color: '#555' }
            }
            className={classes.snsIcon}
            onClick={() => this.moveToSNS('instagram')}
          />
          {/* <TwitterIcon
            style={
              this.state.pathname === 'mypage' || this.state.pathname === 'profile' || this.state.pathname === 'main'
                ? { color: '#fff' }
                : { color: '#555' }
            }
            className={classes.snsIcon}
            onClick={() => this.moveToSNS('twitter')}
          /> */}
          <BookIcon
            style={
              this.state.pathname === 'mypage' || this.state.pathname === 'profile' || this.state.pathname === 'main'
                ? { color: '#fff' }
                : { color: '#555' }
            }
            className={classes.snsIcon}
            onClick={() => this.moveToSNS('pinterest')}
          />
        </div>
        <Toolbar className={classes.toolBar}>
          <Grid container spacing={4} alignItems="baseline">
            <Grid item xs={12} className={classes.flex}>
              <div className={classes.inline}>
                <Link to="/" className={classes.link}>
                  <img
                    src={'/images/doowon_logo_b_color@2x.png'}
                    alt="두원시스템"
                    className={classes.logo}
                    onContextMenu={(e) => e.preventDefault()}
                  />
                </Link>
              </div>
              {!this.props.noTabs && (
                <React.Fragment>
                  <div className={classes.tabContainer}>
                    <SwipeableDrawer
                      anchor="right"
                      open={this.state.menuDrawer}
                      onClose={this.mobileMenuClose}
                      onOpen={this.mobileMenuOpen}
                      style={{ width: '60%' }}
                      classes={{
                        paper: classes.mobileDrawerPaper,
                      }}
                    >
                      <AppBar title="Menu" style={{ width: '80%' }} />
                      <Grid container style={{ padding: '1em 1em 0' }}>
                        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                          {localStorage.getItem('loggedin') ? (
                            <Grid container alignItems="center">
                              <Grid item xs={2} sm={1} style={{ display: 'flex', alignItems: 'center' }}>
                                <Avatar
                                  src={
                                    !this.state.userImg
                                      ? '/images/mypage/default_profile.png'
                                      : /^\b(uploads\/user\/.*)\b$/gi.test(this.state.userImg)
                                      ? `http://61.254.62.162:4002/${this.state.userImg}`
                                      : this.state.userImg
                                  }
                                  className={classes.userProfileImg}
                                  alt="user_profile"
                                />
                              </Grid>
                              <Grid item xs={5} sm={6}>
                                {this.state.userInfo ? (
                                  <Typography style={{ fontSize: '1em' }}>
                                    <span style={{ fontWeight: 'bold' }}>{this.state.userInfo.name}</span> 님
                                  </Typography>
                                ) : (
                                  ''
                                )}
                              </Grid>
                              <Grid item xs={5} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                  size={'medium'}
                                  variant={'contained'}
                                  color={'primary'}
                                  disableElevation
                                  onClick={() => this.logout()}
                                >
                                  <span className={classes.mobileLogoutBtnLabel}>로그아웃</span>
                                </Button>
                              </Grid>
                            </Grid>
                          ) : (
                            <Button
                              fullWidth
                              size={'small'}
                              variant={'outlined'}
                              disableElevation
                              color="primary"
                              classes={{
                                root: classes.mobileStartBtnRoot,
                                label: classes.mobileStartBtnLabel,
                              }}
                              onClick={() => this.props.history.push('login')}
                            >
                              로그인 / 무료로 시작하기
                            </Button>
                          )}
                        </Grid>
                      </Grid>
                      <List style={{ padding: '1em 1em 0' }}>
                        {Dropdown.map((menu, mIdx) => (
                          <React.Fragment key={`list-frag-${mIdx}`}>
                            <ListItem
                              button
                              onClick={(event) => this.handleMobileDropdown(event, menu.label)}
                              key={`listitem-${mIdx}`}
                              style={{ borderBottom: '1px solid rgba(232, 232, 232, 0.5)' }}
                            >
                              <ListItemText
                                primary={menu.label}
                                classes={{ primary: classes.mobileMenuText }}
                                key={`listitem-text-${mIdx}`}
                              />
                            </ListItem>
                            {menu.label === this.state.selectedMenu && (
                              <Collapse
                                in={this.state.isMobileDropdownOpen}
                                timeout="auto"
                                unmountOnExit
                                style={{ borderBottom: '1px solid rgba(232, 232, 232, 0.5)' }}
                                key={`listitem-collapse-${mIdx}`}
                              >
                                {menu.down.map((down, dIdx) => (
                                  <List
                                    component="div"
                                    disablePadding
                                    key={`list-sub-${dIdx}`}
                                    onClick={() => {
                                      // this.props.history.push(down.path);
                                      if (this.props.location.pathname === this.props.history.location.pathname) {
                                        this.props.history.replace(down.path);
                                      } else {
                                        this.props.history.push(down.path);
                                      }
                                    }}
                                    className={classes.mobileDropdownBtn}
                                  >
                                    <ListItem key={`list-sub-item-${dIdx}`}>
                                      <ListItemText classes={{ primary: classes.mobileDropdownText }} key={`list-sub-item-text-${dIdx}`}>
                                        {down.label}
                                      </ListItemText>
                                    </ListItem>
                                  </List>
                                ))}
                              </Collapse>
                            )}
                          </React.Fragment>
                        ))}
                      </List>

                      {/* Topbar SNS area - Mobile */}
                      <div style={{ position: 'absolute', bottom: 0, width: '100%', padding: '0 1em 1em' }}>
                        <Grid container style={{ textAlign: 'center', borderTop: '1px solid rgba(232, 232, 232, 0.5)', paddingTop: '1em' }}>
                          <Grid item xs={3}>
                            <ImHome
                              style={{ color: '#555555', width: '1.15em', height: '1.15em', marginTop: '0.1vh' }}
                              className={classes.snsIcon}
                              onClick={() => this.moveToSNS('homepage')}
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <FacebookIcon
                              style={{ color: '#555555' }}
                              className={classes.snsIcon}
                              onClick={() => this.moveToSNS('facebook')}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <InstagramIcon
                              style={{ color: '#555555' }}
                              className={classes.snsIcon}
                              onClick={() => this.moveToSNS('instagram')}
                            />
                          </Grid>
                          {/* <Grid item xs={3}>
                            <TwitterIcon
                              style={{ color: '#555555' }}
                              className={classes.snsIcon}
                              onClick={() => this.moveToSNS('twitter')}
                            />
                          </Grid> */}
                          <Grid item xs={3}>
                            <BookIcon
                              style={{ color: '#555555' }}
                              className={classes.snsIcon}
                              onClick={() => this.moveToSNS('pinterest')}
                            />
                          </Grid>
                        </Grid>
                      </div>
                    </SwipeableDrawer>

                    <div className="nav">
                      <ul className="nav__menu">
                        {Dropdown.map((menu, index) => (
                          <li className="nav__menu-item" key={`nav-li-${index}`}>
                            <p
                              style={
                                this.state.pathname === 'mypage' || this.state.pathname === 'profile' || this.state.pathname === 'main'
                                  ? { color: '#fff' }
                                  : { color: '#555' }
                              }
                              key={`nav-p-${index}`}
                            >
                              {menu.label}
                            </p>
                            <div className="nav__submenu" key={`nav-div-sub-${index}`}>
                              {Dropdown[index].down.map((sub, subindex) => (
                                <p
                                  className="nav__submenu-item"
                                  onClick={() => {
                                    if (this.props.location.pathname === this.props.history.location.pathname) {
                                      this.props.history.replace(sub.path);
                                    } else {
                                      this.props.history.push(sub.path);
                                    }
                                  }}
                                  key={subindex}
                                >
                                  {sub.label}
                                </p>
                              ))}
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </React.Fragment>
              )}
            </Grid>
          </Grid>

          <Grid item md={4} xs={6}>
            <div
              className={classes.topbarUserInfoDiv}
              // style={window.matchMedia('(max-width:960px)').matches ? { display: 'none' } : { display: 'flex', justifyContent: 'flex-end' }}
            >
              <div style={window.matchMedia('(max-width:960px)').matches ? {} : { display: 'flex', alignItems: 'center' }}>
                {localStorage.getItem('loggedin') ? (
                  <React.Fragment>
                    <Typography
                      style={
                        this.state.pathname === 'mypage' || this.state.pathname === 'profile' || this.state.pathname === 'main'
                          ? { cursor: 'pointer', color: '#fff' }
                          : { cursor: 'pointer', color: '#555' }
                      }
                      aria-owns={Boolean(this.state.anchorElInfo) ? 'userinfo-popover' : undefined}
                      aria-haspopup="true"
                      onMouseEnter={this.handlePopoverClick}
                      onMouseLeave={this.handlePopoverClose}
                    >
                      {this.state.userInfo ? <span style={{ fontWeight: 700 }}>{this.state.userInfo.name} 님</span> : ''}
                    </Typography>
                    <Button
                      size={'medium'}
                      variant={'contained'}
                      color={'primary'}
                      disableElevation
                      onClick={() => this.logout()}
                      className={classes.logoutBtn}
                    >
                      로그아웃
                    </Button>
                    {/* <GoogleLogout
                      clientId={GOOGLE_KEY}
                      buttonText="Logout"
                      onLogoutSuccess={this.snsLogout}
                      onFailure={() => console.log('google logout fail')}
                    ></GoogleLogout> */}
                    <Popover
                      id="userinfo-popover"
                      className={classes.userInfoPopover}
                      classes={{
                        paper: classes.popoverPaper,
                      }}
                      open={Boolean(this.state.anchorElInfo)}
                      onClose={this.handlePopoverClose}
                      anchorEl={this.state.anchorElInfo}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                      }}
                      disableRestoreFocus
                    >
                      {this.state.userInfo ? (
                        <div style={{ textAlign: 'center' }}>
                          <Typography className={classes.userInfoText} style={{ marginBottom: '0.5em' }}>
                            나의 발자취 현황
                          </Typography>
                          <Typography className={classes.userInfoText}>
                            보유 스탬프 : {this.state.userStamp} / {this.state.totalStamp}개
                          </Typography>
                          <Typography className={classes.userInfoText}>
                            완주 코스 : {this.state.userCourse} / {this.state.totalCourse}
                          </Typography>
                          <div style={{ marginTop: '0.5em' }}>
                            <BorderLinearProgress variant="determinate" value={normalise(this.state.userCourse, this.state.totalCourse)} />
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                    </Popover>
                  </React.Fragment>
                ) : (
                  // web login button 지도영역으로 이동
                  <Button
                    size={'medium'}
                    variant={'outlined'}
                    disableElevation
                    onClick={() => this.props.history.push('login')}
                    style={
                      window.matchMedia('(max-width:600px)').matches
                        ? { display: 'none' }
                        : this.state.pathname === 'main'
                        ? { display: 'none' }
                        : this.state.pathname === 'mypage' || this.state.pathname === 'profile' || this.state.pathname === 'main'
                        ? { marginLeft: '15px', textTransform: 'none', color: '#fff', borderColor: '#fff' }
                        : { marginLeft: '15px', textTransform: 'none', color: '#ca502b', borderColor: '#ca502b' }
                    }
                  >
                    로그인 / 무료로 시작하기
                  </Button>
                )}
              </div>
            </div>
            {/* 모바일 메뉴버튼 위치 변경 */}
            <div className={classes.iconContainer}>
              <IconButton
                onClick={this.mobileMenuOpen}
                style={
                  this.state.pathname === 'mypage' || this.state.pathname === 'profile' || this.state.pathname === 'main'
                    ? { color: '#fff' }
                    : { color: '#555' }
                }
                className={classes.iconButton}
                aria-label="Menus"
              >
                <MenuIcon style={{ width: '1.1em !important', height: '1.1em' }} />
              </IconButton>
            </div>
          </Grid>
        </Toolbar>
      </AppBar>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Topbar));
